<template>
  <card
    title="הזמנות ללא מכשיר בסניף"
    :linkTo="`/orders?orderStatuses=${paidStatusId}&startDateBefore=${format(addDays(Date(), 3), 'YYYY-MM-DD')}&officeCheckbox=false&noDelivery=true&receiveTypes=${lametayelReceiveTypeId}`"
    actionButton="לכל ההזמנות ללא מכשיר בסניף"
    :number="number"
    :loading="loading"
    :error="error"
  />
</template>

<script>
import { format, addDays } from 'date-fns';
import { getApi } from '@/api';
import Card from "./Card.vue";

export default {
  data() {
    return {
      number: 0,
      loading: false,
      error: false
    };
  },

  computed: {
    paidStatusId() {
      let paidStatus = Object.values(this.$store.state.entities.orderStatuses).find(item => {
        return item.key === 'PAID';
      })
      return paidStatus ? paidStatus._id : null;
    },
    lametayelReceiveTypeId() {
      let receiveType = Object.values(this.$store.state.entities.receiveTypes).find(item => {
        return item.key === 'LAMETAYEL';
      })
      return receiveType ? receiveType._id : null;
    }
  },

  methods: {
    format,
    addDays,
    fetchData() {
      this.loading = true;
      getApi()
        .then(api => {
          let params = {
            receiveTypes: this.lametayelReceiveTypeId,
            startDateBefore: format(addDays(Date(), 3), 'YYYY-MM-DD'),
            orderStatuses: this.paidStatusId,
            officeCheckbox: false,
            noDelivery: true
          };
          return api.get('/orders', { params })
        })
        .then(({ data }) => {
          this.number = data.totalResults;
        })
        .catch(err => {
          console.log(err);
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        })
    }
  },

  props: [],

  mounted() {
    this.fetchData();
  },

  components: {
    Card
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
